export const FAVORITE_DIALOG_SIDEBAR_ID = 'favorite-dialog-sidebar'
export const FAVORITE_DIALOG_PAGE_ID = 'favorite-dialog-page'
